


















































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import * as c_interface from '@/interface/components/manageGroups';

const namespace: string = 'manageGroup';

@Component
export default class ModalAddress extends Vue {
  @Prop({ type: Boolean, default: false }) dialogVisible!: boolean;
  @Prop({ type: String, default: 'add' }) addressMode!: string;
  @Prop({ type: String, default: 'defaultId' }) updateAddressId!: string;

  @Action('getAddresses', { namespace }) c_getAddresses!: any;
  @Action('getAddress', { namespace }) c_getAddress!: any;
  @Action('setAddress', { namespace }) c_setAddress!: any;
  @Action('updateAddress', { namespace }) c_updateAddress!: any;

  @Getter('getterAddressItem', { namespace })
  c_getterAddressItem!: c_interface.CreateAddressPayload;

  public propsDialogVisible: boolean = this.dialogVisible;
  public ruleForm: c_interface.CreateAddressPayload = {
    organization: '',
    name: '',
    address: '',
    detailAddress: '',
    zip: '',
    phoneNumber1: '',
    phoneNumber2: '',
    city: '',
    state: '',
    isActive: false,
    verified: false,
  };
  public rules: any = {
    organization: [
      { required: true, message: '배송지명을 입력해주세요.', trigger: ['blur', 'change'] },
    ],
    name: [{ required: true, message: '담당자명을 입력해주세요.', trigger: ['blur', 'change'] }],
    address: [{ required: true, message: '주소를 입력해주세요.', trigger: ['blur', 'change'] }],
    detailAddress: [
      { required: true, message: '상세주소를 입력해주세요.', trigger: ['blur', 'change'] },
    ],
    phoneNumber1: [
      { required: true, message: '연락처를 입력해주세요.', trigger: ['blur', 'change'] },
    ],
  };

  @Emit('emitModalClose')
  modalClose(): boolean {
    this.propsDialogVisible = false;
    return this.propsDialogVisible;
  }

  async created() {
    const groupId: string = this.$route.params.groupId;
    if (this.addressMode === 'update') {
      try {
        await this.c_getAddress({
          groupId,
          addressId: this.updateAddressId,
        });
        this.ruleForm = this.c_getterAddressItem;
      } catch (e) {
        console.log(e);
        this.$message.error(e.response.data.error.message);
      }
    }
  }

  addSubmit() {
    const groupId: string = this.$route.params.groupId;
    (this.$refs['ruleForm'] as HTMLFormElement).validate(async (valid: boolean) => {
      if (valid) {
        try {
          if (this.addressMode === 'update') {
            await this.c_updateAddress({
              groupId,
              addressId: this.updateAddressId,
              payload: this.ruleForm,
            });
          } else {
            await this.c_setAddress({
              groupId,
              payload: this.ruleForm,
            });
          }
          this.propsDialogVisible = false;
          this.$emit('emitUpdateSubmit', false);
          await this.c_getAddresses(groupId);
        } catch (e) {
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      } else {
        this.$message.error('유효하지 않은 형식의 데이터가 있습니다.');
        return false;
      }
    });
  }

  execDaumPostcode() {
    //아래 코드처럼 테마 객체를 생성합니다.(color값은 #F00, #FF0000 형식으로 입력하세요.)
    //변경되지 않는 색상의 경우 주석 또는 제거하시거나 값을 공백으로 하시면 됩니다.
    const themeObj = {
      //bgColor: "", //바탕 배경색
      searchBgColor: '#0B65C8', //검색창 배경색
      //contentBgColor: "", //본문 배경색(검색결과,결과없음,첫화면,검색서제스트)
      //pageBgColor: "", //페이지 배경색
      //textColor: "", //기본 글자색
      queryTextColor: '#FFFFFF', //검색창 글자색
      //postcodeTextColor: "", //우편번호 글자색
      //emphTextColor: "", //강조 글자색
      //outlineColor: "", //테두리
    };

    // @ts-ignore
    new daum.Postcode({
      theme: themeObj,
      oncomplete: (data: any) => {
        // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
        let addr = ''; // 주소 변수

        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
        if (data.userSelectedType === 'R') {
          // 사용자가 도로명 주소를 선택했을 경우
          addr = data.roadAddress;
        } else {
          // 사용자가 지번 주소를 선택했을 경우(J)
          addr = data.jibunAddress;
        }

        // 우편번호와 주소 정보를 해당 필드에 넣는다.
        this.ruleForm.city = data.sido;
        this.ruleForm.state = data.sigungu;
        this.ruleForm.zip = data.zonecode;
        this.ruleForm.address = addr;
        // @ts-ignore
        document.getElementById('detailAddress').focus();
      },
    }).open();
  }
}
